import CompraInformacoesNotaFiscal from './CompraInformacoesNotaFiscal';

export default CompraInformacoesNotaFiscal;
